// src/utils/api.js — API helper with auth headers
// Merged portal uses ONE login/token pair (dms_token / dms_user) across all
// 14 tabs — the old warehouse-portal convention (wh_token/wh_user) is gone
// since there's only one portal now. getUser() is included because the
// warehouse-sourced pages (AssignDeliveries, StageOverride, Vouchers,
// QueuePage) import it.

const BASE = '';

export function getToken() {
  return localStorage.getItem('dms_token');
}

export function getUser() {
  return JSON.parse(localStorage.getItem('dms_user') || '{}');
}

async function api(path, options = {}) {
  const token = getToken();
  const headers = {
    'Content-Type': 'application/json',
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...options.headers,
  };

  const res = await fetch(BASE + path, { ...options, headers });

  if (res.status === 401) {
    localStorage.removeItem('dms_token');
    localStorage.removeItem('dms_user');
    window.location.href = '/';
    return;
  }

  const data = await res.json().catch(() => ({}));
  if (!res.ok) throw new Error(data.error || data.message || `HTTP ${res.status}`);
  return data;
}

export const get   = (path) => api(path);
export const post  = (path, body) => api(path, { method: 'POST', body: JSON.stringify(body) });
export const patch = (path, body) => api(path, { method: 'PATCH', body: JSON.stringify(body) });
export const del   = (path) => api(path, { method: 'DELETE' });

export default api;
